import { buildEnViewsText } from './viewsText'

// 英文国际化展示
const en = {
  system: {
    name: 'CZM Data Center',
    chinese: 'Chinese',
    english: 'English',
    confirm: 'Confirm',
    cancel: 'Cancel',
    warning: 'Warning',
    next: 'Next',
    prev: 'Previous',
    yes: 'Yes',
    no: 'No',
    add: 'Add',
    edit: 'Edit',
    finish: 'Finish',
    back: 'Back',
    update: 'Update',
    search: 'Search',
    reset: 'Reset',
    export: 'Export'
  },

  title: {
    saleManagement: 'Sale Order'
  },

  login: {
    email: 'Email',
    password: 'Password',
    sign_in: 'Sign In',
    welcome: '👏Welcome Back',
    lost_password: 'Forgot password?',
    remember: 'Remember me',
    verify: {
      email: {
        required: 'Please enter your email first',
        invalid: 'Invalid email address'
      },
      password: {
        required: 'Please enter your password first'
      }
    }
  },

  register: {
    sign_up: 'Sign Up'
  },

  generate: {
    schema: {
      title: 'Create Table',
      name: 'Table Name',
      name_verify: 'Please enter table name',
      engine: {
        name: 'Table Engine',
        verify: 'Please select table engine',
        placeholder: 'Select table engine'
      },
      default_field: {
        name: 'Default Fields',
        created_at: 'Created Time',
        updated_at: 'Updated Time',
        creator: 'Creator',
        delete_at: 'Soft Delete'
      },
      comment: {
        name: 'Table Comment',
        verify: 'Please enter table comment/description'
      },
      structure: {
        title: 'Create Table Structure',
        field_name: {
          name: 'Field Name',
          verify: 'Please enter field name'
        },
        length: 'Length',
        type: {
          name: 'Type',
          placeholder: 'Select field type',
          verify: 'Please select field type'
        },
        form_label: 'Form Label',
        form_component: 'Form Component',
        list: 'List',
        form: 'Form',
        unique: 'Unique',
        search: 'Search',
        search_op: {
          name: 'Search Operator',
          placeholder: 'Select search operator'
        },
        nullable: 'Nullable',
        default: 'Default Value',
        rules: {
          name: 'Validation Rules',
          placeholder: 'Select validation rules'
        },
        operate: 'Operation',
        comment: 'Field Comment'
      }
    },
    code: {
      title: 'Generate Code',
      module: {
        name: 'Module',
        placeholder: 'Please select module',
        verify: 'Please select module'
      },
      controller: {
        name: 'Controller',
        placeholder: 'Please enter controller name',
        verify: 'Please enter controller name'
      },
      model: {
        name: 'Model',
        placeholder: 'Please enter model name',
        verify: 'Please enter model name'
      },
      paginate: 'Pagination',
      menu: {
        name: 'Menu Name',
        placeholder: 'Please enter menu name',
        verify: 'Please enter menu name'
      }
    }
  },

  module: {
    create: 'Create Module',
    update: 'Update Module',
    form: {
      name: {
        title: 'Module Name',
        required: 'Please enter module name'
      },
      path: {
        title: 'Module Directory',
        required: 'Please enter module directory'
      },
      desc: {
        title: 'Module Description'
      },
      keywords: {
        title: 'Module Keywords'
      },
      dirs: {
        title: 'Default Directories',
        Controller: 'Controller Directory',
        Model: 'Model Directory',
        Database: 'Database Directory',
        Request: 'Request Directory'
      }
    }
  },

  viewsText: {
    ...buildEnViewsText()
  }
}

export default en
